/**
 * A {@code Model} for maintaining the list of Variables supported by the application.
 */
import SelectableItemModel from './selectable-item-model';

export default class VariablesModel extends SelectableItemModel {

  /**
   * Utility class to cache the list of Variables defined by the specified dataset. This function
   * does not cause any events to be fired. This should be handled externally to this model.
   */
  load(dataset) {

    // Copy the list of Variables.
    const _variables = (dataset && dataset.variables ?
        JSON.parse(JSON.stringify(dataset.variables)) :
        []
    );

    // Cache field information for each Variable.
    if (dataset.type === 'msp1') {
      _variables.forEach(variable => {
        const field = dataset.fields.find(field => {
          return field.id === variable.fieldId;
        });
        if (field) {
          variable.isNumerical = field.type === 'numerical';
          variable.fieldName = field.fieldName;
        }

      });
    }

    // Update the internal caches.
    this._internalCache = _variables;
    this.emit(this.ON_LIST_CHANGE_EVENT, this._internalCache);

    // Select the first variable.
    this._selectedItem = this._internalCache.length > 0 ? this._internalCache[0] : undefined;
    this.emit(this.ON_SELECTION_EVENT, this._selectedItem);

  }

}



// WEBPACK FOOTER //
// ./src/app/models/variables-model.js